import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import AttachmentComponent from "../AttachmentComponent";

function AttachmentModal({ open, close, loading, setShowCamera, setLoading, handleUpload, setInputValue = () => {} }) {
  const style = {
    position: "absolute",
    bottom: { xs: 0, sm: "-2%", md: "-3%", lg: 0, xl: 0 },
    right: { xs: "10%", sm: "-13%", md: "-10%", lg: "-6.5%", xl: "-4.5%" },
    width: "244px",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    overflowY: "auto",
    scrollbarWidth: "none",
    maxHeight: 400,
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0)",
          },
        }}
      >
        <Box sx={style}>
          <AttachmentComponent close={close} loading={loading} setShowCamera={setShowCamera} setLoading={setLoading} handleUpload={handleUpload} setInputValue={setInputValue} />
        </Box>
      </Modal>
    </div>
  );
}

export default AttachmentModal;
